<template>
    <div style="min-height: 600px; height: 100%; width: 100%">
        <l-map
            v-if="showMap"
            :zoom="currentZoom"
            :center="currentCenter"
            :options="mapOptions"
            style="height: 100%"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
            :noBlockingAnimations="true"
        >
            <l-tile-layer
                :url="url"
                :attribution="attribution"
            />
            <l-marker
                v-for="icon in icons"
                :lat-lng="icon.position"
                :icon="icon.icon"
                :key="icon.id"
            >
            <l-popup>
                <StoreInfos :storeId="icon.id" display-title />
            </l-popup>
            </l-marker>
        </l-map>
    </div>
</template>

<script>
    import { latLng, icon } from 'leaflet'
    import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
    import StoreInfos from './StoreInfos.vue'

    export default {
        name : 'StoresMap',

        components : {
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            StoreInfos,
        },

        props : {
            searchedPosition : {
                type : Object,
                required : false,
            },
        },

        store : {
            stores : 'stores',
        },

        data() {
            return {
                url : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution : '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                showMap : true,
                mapOptions : {
                    zoomSnap : 0.5
                },
                currentZoom : 6,
                currentCenter : latLng(47.0833300, 2.4000000)
            }
        },

        computed : {
            icons() {
                return this.stores.map(store => {
                    return {
                        icon:  icon({
                            iconUrl: "/static/android-chrome-192x192.png",
                            iconSize: [32, 32],
                            iconAnchore: [32, 32],
                        }),
                        id : store.id,
                        position : latLng(
                            store.position.coordinates[1],
                            store.position.coordinates[0],
                        ),
                    }
                })
            },
        },

        methods : {
            zoomUpdate(zoom) {
                this.currentZoom = zoom;
            },
            centerUpdate(center) {
                this.currentCenter = center;
            },
        },

        watch: {
            'searchedPosition' : {
                handler() {
                    if (this.searchedPosition) {
                        this.centerUpdate(latLng(this.searchedPosition.coordinates[1], this.searchedPosition.coordinates[0]))
                        this.zoomUpdate(11)
                    }
                }
            }
        }
    }
</script>
